import { deepEquals } from 'app/infrastructure/js';
import { ExternalUrlItem } from '../types-store';

export const hasChanges = (item?: ExternalUrlItem, original?: ExternalUrlItem): boolean => {

  const compare = item?.id !== original?.id ||
    item?.description !== original?.description ||
    item?.urlTemplate !== original?.urlTemplate ||
    item?.disabled?.getTime() !== original?.disabled?.getTime();

  if (compare) {
    return true;
  }

  const excludeFields = !deepEquals(item?.excludeFields?.map(field => field.value),
    original?.excludeFields?.map(field => field.value));

  if (excludeFields) {
    return true;
  }

  const language = ((item ?? {}).language ?? [])
    .filter(languageItem => (languageItem.description ?? '').trim().length > 0);
  const originalLanguage = ((original || {}).language || [])
    .filter(languageItem => (languageItem.description ?? '').trim().length > 0);

  if (language.length !== originalLanguage.length) {
    return true;
  }

  if (language.some(
    languageItem => !originalLanguage.some(
      originalLanguageItem => (languageItem.value ?? '') === (originalLanguageItem.value ?? '') &&
        (languageItem.description ?? '') === (originalLanguageItem.description ?? ''))
  )) {
    return true;
  }

  const longDescription = ((item ?? {}).longDescription ?? [])
    .filter(longDescriptionItem => (longDescriptionItem.description ?? '').trim().length > 0);
  const originallongDescription = ((original || {}).longDescription || [])
    .filter(longDescriptionItem => (longDescriptionItem.description ?? '').trim().length > 0);

  if (longDescription.length !== originallongDescription.length) {
    return true;
  }

  if (longDescription.some(
    longDescriptionItem => !originallongDescription.some(
      originalLongDescriptionItem => (longDescriptionItem.value ?? '') === (originalLongDescriptionItem.value ?? '') &&
        (longDescriptionItem.description ?? '') === (originalLongDescriptionItem.description ?? ''))
  )) {
    return true;
  }

  return false;
};
